import * as e from "react";
import r from "../lib/IconBase.es.js";
import a from "../defs/TextIndent.es.js";
const t = e.forwardRef((o, n) => /* @__PURE__ */ e.createElement(r, { ref: n, ...o, weights: a }));
t.displayName = "TextIndentIcon";
const s = t;
export {
  s as TextIndent,
  t as TextIndentIcon
};
